import { connect } from 'react-redux';
import { AppState, ClassificationAnswers } from '../redux/app.reducer';
import { Tool } from '../customization';

export type LabelInfo = {
  id: string;
  text: string;
};

export type LabelInfoProps = {
  labels: LabelInfo[];
};

const formatClassificationAnswers = (answers: ClassificationAnswers | undefined) => {
  if(!answers) {
    return '';
  }
  const values = Object.keys(answers)
    .sort((one, two) => (one > two ? -1 : 1))
    .map((key) => answers[key])
    .filter(Boolean)
    .reduce<string[]>((accum, value: string | string[]) => {
      if(Array.isArray(value)) {
        return [...accum, ...value];
      }
      return [...accum, value];
    }, []);

  return values.length ? `(${values.join(', ')})` : '';
};

const mapStateToProps = ({ app } : { app: AppState }): LabelInfoProps => {
  const { annotations, showLabelInfo, tools } = app;
  if (!showLabelInfo || annotations.length === 0) {
    return { labels: [] };
  }

  const labels = annotations.map(({ id: annotationId, geometry, toolId, classificationAnswers }) => {
    const { name } = tools.find(({ id }) => id === toolId) as Tool;

    const answers = formatClassificationAnswers(classificationAnswers);
    return {
      id: annotationId,
      text: answers ? `${name} ${answers}` : name,
    };
  });

  return { labels };
};

export const withLabelInfo = connect(mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/label-info.ts